<template>
	<el-dialog
	  :title="type==1?'发布博客':'修改博客'"
	  :visible.sync="dialogVisible"
	  top="2vh"
	  width="60%">
	  <uploadimg @upload="uploadddd" ref="uploadFileClick" style="display: none;"></uploadimg>
	  <el-form :model="dataForm" ref="dataForm" :rules="rules">
		  <el-form-item label="博客标题" prop="t
		  
		  
		  itle" label-width="100px">
			  <el-input placeholder="请输入标题" v-model="dataForm.title"></el-input>
		  </el-form-item>
		  <el-form-item label="文章来源" label-width="100px">
		  	 <el-input placeholder="请输入文章来源" v-model="dataForm.laiyuan"></el-input>
		  </el-form-item>
		  <el-form-item label="原作者" label-width="100px">
		  	 <el-input placeholder="请输入原作者" v-model="dataForm.zuozhe"></el-input>
		  </el-form-item>
		  <el-form-item label="博客内容" prop="content" label-width="100px">
		  	<mavon-editor
		  			 v-model="dataForm.content" 
		  			 ref="md"
		  			 @imgAdd="handleEditorImgAdd"
					 style="height: 400px;"
		  			  />
		  </el-form-item>
		  <el-form-item label="" label-width="100px">
			  <el-button @click="dialogVisible=false">取消</el-button>
			  <el-button type="success" @click="save">确认发布</el-button>
		  </el-form-item>
	  </el-form>
	</el-dialog>
</template>

<script>
	import { user_boke_save } from "@/api/boke"
	import uploadimg from "@/common/ImgUpload.vue"
	import { uploadOss } from "@/api/config"
	export default{
		components:{
			uploadimg
		},
		data(){
			let that = this;
			return{
				type:1,
				dialogVisible:false,
				dataForm:{
					id:null,
					title:'',
					content:'',
					laiyuan:'',
					zuozhe:'',
					imgurl:''
				},
				rules:{
					title:[{ required: true, message: '标题必填', trigger: 'blur' }],
					content:[{ required: true, message: '内容必填', trigger: 'blur' }],
				},
				zhuanti:[],//专题
			}
		},
		watch:{
			dialogVisible(e){
				if(e==false){
					this.dataForm = {
						id:null,
						title:'',
						content:'',
						laiyuan:'',
						zuozhe:'',
						imgurl:''
					}
				}
			},
		},
		mounted(){
			
		},
		methods:{
			handleEditorImgAdd(pos,file){
				console.log("添加图片");
				let that = this;
				console.log("pos",pos);
				console.log("file",file);
				var formdata = new FormData();
				formdata.append("file", file);
				const loading = this.$loading({
						lock: true,
						text: '上传中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
				});
				uploadOss(formdata).then(res=>{
					loading.close();
					this.$refs.md.$img2Url(pos, res.data);
				}).catch(()=>{
					loading.close();
				})
			},
			handlecreate(type,info){
				this.type = type
				this.dialogVisible = true
				if(type==2){
					this.dataForm = {
						id:info.id,
						title:info.title,
						content:info.content,
						laiyuan:info.laiyuan,
						zuozhe:info.zuozhe,
						imgurl:info.imgurl
					}
				}
			},
			//提交方法
			async save(){
			  let that = this;
			  that.$refs['dataForm'].validate((valid) => {
			    if (valid) {
			        const loading = this.$loading({
			            lock: true,
			            text: '发布中',
			            spinner: 'el-icon-loading',
			            background: 'rgba(0, 0, 0, 0.7)'
			          });
			         user_boke_save(this.dataForm).then((res)=>{
						 loading.close();
						 this.$message.success("发布成功");
						 console.log("发布成功",res.data);
						 this.dialogVisible = false
						 this.$emit("succ",res.data.id);
					 }).catch(()=>{
						 loading.close();
					 })
			    } else {
			      console.log("error");
			    }
			  })
			},
		},
	}
</script>

<style lang="scss">
 .editor .ql-editor{
	 height: 400px;
 }
</style>


// WEBPACK FOOTER //
// src/views/luntan/boke/components/save.vue